// extracted by mini-css-extract-plugin
export default {"list":"MainList_list__9nO-E","title":"MainList_title__JR+qT","descr":"MainList_descr__gcqey"};